<template>
  <div class="filter-item">
    <span v-for="(filterItem, index) in filterList" :key="'filter_' + index">
      <vod-filter-item :filter-item="filterItem" :base-api="baseApi" />
    </span>
  </div>
</template>
<script>
import _ from 'lodash'
import VodFilterItem from '@/pages/list/VodFilterItem'
export default {
  name: 'VodAllListFilterList',
  components: {
    VodFilterItem
  },
  props: {
    filter: {
      type: Object
    }
  },
  data () {
    return {
      filterList: [],
      baseApi: ''
    }
  },
  mounted () {
    this.filterList = _.get(this.filter, 'filterlist', [])
    this.baseApi = _.get(this.filter, 'baseapi', '')
  }
}
</script>
